import Vue from "vue";

// Bus de eventos para coordinar el arrastre entre el Home (dashboard) y el
// dock (Footer), que son componentes distintos.
//   drag:start {funcId, origin}
//   drag:move  {x, y}
//   drag:drop  {funcId, origin, x, y}
//   drag:end
export const dockBus = new Vue();
